import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputComponent } from '../../../../components/InputComponent';
import { CatalogoService } from '../../../../service/CatalogoService';
import * as generic from '../../../../components/Generico';
import { InformacionGeneral } from '../../../../models/trust/cliente/InformacionGeneral';
import { ClientePnService } from '../../../../service/trust/ClientePnService';
import { Panel } from 'primereact/panel';
import { BottomActionBar } from '../../../../components/ui/BottomActionBar';

export const InfoGeneral = ({ toast, id, permss, catalogos, handleNext, nuevoCliente, soloLectura }) => {

    const omodel = new InformacionGeneral();
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue, clearErrors, watch, trigger } = useForm({ defaultValues, shouldTrim: true, mode: 'onTouched' });
    const clienteServicio = new ClientePnService();
    const catalogoService = new CatalogoService();
    const { inDrop, inText, inCalendar, inArea, inNumber } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [ecuador, setEcuador] = useState(false);
    const [ciudades, setCiudades] = useState([]);
    const [ecuadorBien, setEcuadorBien] = useState(false);
    const [ciudadesBien, setCiudadesBien] = useState([]);
    const [ecuadorCanal, setEcuadorCanal] = useState(false);
    const [ciudadesCanal, setCiudadesCanal] = useState([]);
    const [esRuc, setEsRuc] = useState(false);
    const [esCedula, setEsCedula] = useState(false);
    const [esCasado, setEsCasado] = useState(null);

    const fechaNacimiento = watch('fecha_nacimiento');

    useEffect(() => {
        if (fechaNacimiento) {
            // Llamamos directamente a la función mejorada de tu generic
            const edad = generic.calcularEdad(fechaNacimiento);
            setValue('edad', edad);
        } else {
            setValue('edad', null);
        }
    }, [fechaNacimiento, setValue]);

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id]);

    const onSubmit = (data) => {
        setIsSaving(true);
        data.ec = catalogos?.ecuador;
        data.casado = catalogos?.casado;
        data.union = catalogos?.union;
        data.fecha = generic.dateToString(data.fecha);
        data.fecha_nacimiento = generic.dateToString(data.fecha_nacimiento);
        data.seccion = 'seccion1';

        if (id == null) {
            clienteServicio.newCliente(data).then(res => {
                nuevoCliente(res.data);
                generic.funcSuccess(res, toast);
                handleNext();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => setIsSaving(false));
        } else {
            data.id = id;
            clienteServicio.editarCliente(data).then(res => {
                nuevoCliente(res.data);
                generic.funcSuccess(res, toast);
                handleNext();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => setIsSaving(false));
        }
    }

    const editFicha = () => {
        setIsLoading(true);
        clienteServicio.consultarCliente(id ?? 0, { seccion: 'seccion1' }).then(res => {
            const cats = catalogos;
            const _cli = res.data.cliente;

            if (!_cli) {
                reset(defaultValues);
                setIsLoading(false);
                return;
            }
            setEsCasado(_cli.estado_civil?.cat_id === cats?.casado?.cat_id || _cli.estado_civil?.cat_id === cats?.union?.cat_id);

            setEcuador(_cli.pais_residencia?.cat_id === cats?.ecuador?.cat_id);
            if (res.data.ciudades_residencia !== undefined) {
                setCiudades(res.data.ciudades_residencia);
            }

            setEcuadorBien(_cli.pais_bien?.cat_id === cats?.ecuador?.cat_id);
            if (res.data.ciudades_bien !== undefined) {
                setCiudadesBien(res.data.ciudades_bien);
            }

            setEcuadorCanal(_cli.pais_canal?.cat_id === cats?.ecuador?.cat_id);
            if (res.data.ciudades_canal !== undefined) {
                setCiudadesCanal(res.data.ciudades_canal);
            }

            _cli.fecha = generic.stringToDate(_cli.fecha);
            _cli.fecha_nacimiento = generic.stringToDate(_cli.fecha_nacimiento);

            setEsRuc(_cli.tipo_identificacion?.cat_id === cats?.ruc?.cat_id);
            setEsCedula(_cli.tipo_identificacion?.cat_id === cats?.cedula?.cat_id);

            nuevoCliente({ id: _cli.id, nemonico: _cli.nemonico });
            reset(generic.renewValues(_cli, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const onChangePais = (e) => {
        setEcuador(e.value?.cat_id === catalogos?.ecuador?.cat_id);
        setValue('provincia_residencia', null);
        setValue('ciudad_residencia', null);
        setCiudades([]);
        if (getValues('telefono')) {
            trigger('telefono');
        }
        if (getValues('celular')) {
            trigger('celular');
        }
    }

    const onChangeProvincia = (e) => {
        setValue('ciudad_residencia', null);
        if (!e?.value) { setCiudades([]); return; }
        catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudades(res.data));
    }

    const onChangePaisBien = (e) => {
        setEcuadorBien(e.value?.cat_id === catalogos?.ecuador?.cat_id);
        setValue('provincia_bien', null);
        setValue('ciudad_bien', null);
        setCiudadesBien([]);
    };

    const onChangeProvinciaBien = (e) => {
        setValue('ciudad_bien', null);
        if (!e?.value) { setCiudadesBien([]); return; }
        catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudadesBien(res.data));
    };

    const onChangePaisCanal = (e) => {
        setEcuadorCanal(e.value?.cat_id === catalogos?.ecuador?.cat_id);
        setValue('provincia_canal', null);
        setValue('ciudad_canal', null);
        setCiudadesCanal([]);
    };

    const onChangeProvinciaCanal = (e) => {
        setValue('ciudad_canal', null);
        if (!e?.value) { setCiudadesCanal([]); return; }
        catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudadesCanal(res.data));
    };

    const onChangeEstadoCivil = (e) => {
        let _esCasado = false;
        if (e?.value) {
            _esCasado = (e.value?.cat_id === catalogos?.casado?.cat_id || e.value?.cat_id === catalogos?.union?.cat_id);
        }
        setEsCasado(_esCasado);
    }

    const onChangeTipo = (e) => {
        setEsRuc(e.value?.cat_id === catalogos?.ruc?.cat_id);
        setEsCedula(e.value?.cat_id === catalogos?.cedula?.cat_id);
        clearErrors('identificacion');
    }

    const tipoDoc = esRuc ? 'IDEN_RUC' : esCedula ? 'IDEN_CEDULA' : null;

    const reglaValidacion = (val) => {
        if (!tipoDoc) return true;
        return generic.validarIdentificacionEcuador(val, tipoDoc) || `${esRuc ? 'RUC' : 'Cédula'} incorrecto`;
    };

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
            <Panel header={generic.renderPanelHeader('A', 'INFORMACIÓN GENERAL', 'pi pi-file-edit')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {inCalendar('fecha', {}, 3)}
                    {inText('apellido_paterno', { icon: 'pi pi-user' }, 3)}
                    {inText('apellido_materno', { icon: 'pi pi-user' }, 3)}
                    {inText('nombres', { icon: 'pi pi-user' }, 3)}

                    {inDrop('tipo_identificacion', catalogos?.tipo_identificacion, { lab: omodel.optionLabel, chn: onChangeTipo }, 3)}
                    {inText('identificacion', { validate: reglaValidacion, icon: 'pi pi-id-card' }, 3)}
                    {inCalendar('fecha_nacimiento', {}, 3)}
                    {inNumber('edad', 0, false, { disabled: true }, 3)}

                    {inDrop('genero', catalogos?.genero, { lab: omodel.optionLabel }, 4)}
                    {inDrop('estado_civil', catalogos?.estado_civil, { lab: omodel.optionLabel, chn: onChangeEstadoCivil }, 4)}
                    {inDrop('nacionalidad', catalogos?.nacionalidad, { lab: omodel.optionLabel }, 4)}

                    <div className="col-12 mt-2 mb-2"><div className="border-top-1 border-300"></div></div>

                    {inDrop('pais_residencia', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePais }, ecuador ? 4 : 6)}
                    {ecuador ? (
                        <>
                            {inDrop('provincia_residencia', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvincia }, 4)}
                            {inDrop('ciudad_residencia', ciudades, { lab: omodel.optionLabel }, 4)}
                        </>
                    ) : (
                        inText('canton_residencia', { icon: 'pi pi-map-marker' }, 6)
                    )}

                    {inArea('direccion_residencia', 3, 100, 12)}

                    {inDrop('tipo_vivienda', catalogos?.tipo_vivienda, { lab: omodel.optionLabel }, 3)}
                    {inText('telefono', { icon: 'pi pi-phone', validate: generic.validarTelefonoDinamico(getValues, 'pais_residencia') }, 3)}
                    {inText('celular', { icon: 'pi pi-mobile', validate: generic.validarTelefonoDinamico(getValues, 'pais_residencia') }, 3)}
                    {inDrop('tipo_contacto', catalogos?.tipo_contacto, { lab: omodel.optionLabel }, 3)}
                    {inText('email', { icon: 'pi pi-envelope', pattern: generic.VALIDACION_EMAIL }, 12)}

                    {esCasado && (
                        <>
                            <div className="col-12 mt-3 mb-2">
                                <span className="text-700 font-bold text-sm flex align-items-center gap-2">
                                    <i className="pi pi-users text-primary"></i>
                                    DATOS DEL CÓNYUGE
                                </span>
                                <div className="border-top-1 border-300 mt-2"></div>
                            </div>

                            {inText('nombre_completo_cy', { icon: 'pi pi-user' }, 12)}
                            {inDrop('tipo_identificacion_cy', catalogos?.tipo_identificacion, { lab: omodel.optionLabel, chn: onChangeTipo }, 4)}
                            {inText('identificacion_cy', { validate: reglaValidacion, icon: 'pi pi-id-card' }, 4)}
                            {inDrop('nacionalidad_cy', catalogos?.nacionalidad, { lab: omodel.optionLabel }, 4)}
                        </>
                    )}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('', 'INFORMACIÓN DE LA OPERACIÓN Y TRANSACCIÓN', 'pi pi-briefcase')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {inDrop('tipo_estructura', catalogos?.tipo_estructura, { lab: omodel.optionLabel }, 4)}
                    {inDrop('tipo_bien', catalogos?.tipo_bien, { lab: omodel.optionLabel }, 4)}
                    {inNumber('monto', 2, true, { placeholder: 'Ej. 25000.00' }, 4)}
                    {inDrop('pais_bien', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePaisBien }, ecuadorBien ? 4 : 6)}
                    {ecuadorBien ? (
                        <>
                            {inDrop('provincia_bien', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvinciaBien }, 4)}
                            {inDrop('ciudad_bien', ciudadesBien, { lab: omodel.optionLabel }, 4)}
                        </>
                    ) : (
                        inText('canton_bien', { placeholder: 'Ingrese la ciudad / cantón del bien o servicio', icon: 'pi pi-map-marker' }, 6)
                    )}
                    <div className="col-12 my-2">
                        <span className="text-700 font-bold text-sm flex align-items-center gap-2">
                            <i className="pi pi-credit-card text-primary"></i>
                            CANAL Y FORMA DE PAGO
                        </span>
                        <div className="border-top-1 border-300 mt-2"></div>
                    </div>
                    {inDrop('tipo_transaccion', catalogos?.tipo_transaccion, { lab: omodel.optionLabel }, 4)}
                    {inDrop('instrumento', catalogos?.instrumento, { lab: omodel.optionLabel }, 4)}
                    {inDrop('pais_fondo', catalogos?.pais, { lab: omodel.optionLabel }, 4)}
                    {inDrop('pais_canal', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePaisCanal }, ecuadorCanal ? 4 : 6)}
                    {ecuadorCanal ? (
                        <>
                            {inDrop('provincia_canal', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvinciaCanal }, 4)}
                            {inDrop('ciudad_canal', ciudadesCanal, { lab: omodel.optionLabel }, 4)}
                        </>
                    ) : (
                        inText('canton_canal', { placeholder: 'Ingrese la ciudad / cantón del canal del servicio', icon: 'pi pi-map-marker' }, 6)
                    )}
                </div>
            </Panel>

            <BottomActionBar layoutVersion="v2" onNext={handleNext} loading={isSaving} isReadOnly={soloLectura} />
        </form>
    );
}
